var _style, _defs, _polygon, _g, _defs2, _rect, _defs3, _polygon2, _path, _defs4, _defs5, _polygon3, _defs6, _defs7, _rect2, _defs8, _path2, _defs9, _path3, _defs10, _rect3, _defs11, _rect4, _defs12, _defs13, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "902px",
    height: "184.2px",
    viewBox: "0 0 902 184.2",
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 902 184.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6E3CE1;}\r\n\t.st1{fill:#FFD500;}\r\n\t.st2{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\r\n\t.st3{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\r\n\t.st4{fill:#63E9C1;}\r\n\t.st5{opacity:0.75;}\r\n\t.st6{clip-path:url(#SVGID_8_);}\r\n\t.st7{clip-path:url(#SVGID_10_);fill:url(#SVGID_11_);}\r\n\t.st8{clip-path:url(#SVGID_13_);}\r\n\t.st9{clip-path:url(#SVGID_15_);fill:url(#SVGID_16_);}\r\n\t.st10{opacity:0.8;}\r\n\t.st11{clip-path:url(#SVGID_18_);fill:#5E0287;}\r\n\t.st12{opacity:0.5;}\r\n\t.st13{clip-path:url(#SVGID_20_);fill:#480378;}\r\n\t.st14{clip-path:url(#SVGID_22_);fill:url(#SVGID_23_);}\r\n\t.st15{clip-path:url(#SVGID_25_);fill:url(#SVGID_26_);}\r\n\t.st16{opacity:0.3;}\r\n\t.st17{clip-path:url(#SVGID_28_);}\r\n\t.st18{clip-path:url(#SVGID_30_);fill:url(#SVGID_31_);}\r\n\t.st19{clip-path:url(#SVGID_33_);fill:url(#SVGID_34_);}\r\n\t.st20{clip-path:url(#SVGID_36_);fill:url(#SVGID_37_);}\r\n\t.st21{clip-path:url(#SVGID_39_);}\r\n\t.st22{clip-path:url(#SVGID_41_);fill:url(#SVGID_42_);}\r\n\t.st23{clip-path:url(#SVGID_44_);}\r\n\t.st24{clip-path:url(#SVGID_46_);fill:url(#SVGID_47_);}\r\n\t.st25{clip-path:url(#SVGID_49_);fill:#5E0287;}\r\n\t.st26{clip-path:url(#SVGID_51_);fill:#480378;}\r\n\t.st27{clip-path:url(#SVGID_53_);fill:url(#SVGID_54_);}\r\n\t.st28{clip-path:url(#SVGID_56_);fill:url(#SVGID_57_);}\r\n\t.st29{clip-path:url(#SVGID_59_);}\r\n\t.st30{clip-path:url(#SVGID_61_);fill:url(#SVGID_62_);}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "859.3,170.4 839.2,138.3 819.1,170.4 776.6,170.4 818,109.7 776.6,48.8 819.1,48.8 839.2,81.1  859.3,48.8 902,48.8 860.6,109.7 902,170.4  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.1,133.1c0,10-3.5,18.7-10.7,26.1c-7.1,7.4-15.5,11.2-25.3,11.2h-78.5v-33.6h74.1c0.9,0,1.7-0.2,2.4-0.6 c0.8-0.4,1.5-0.9,2.1-1.5c0.6-0.6,1.1-1.3,1.5-2.1s0.6-1.6,0.6-2.5c0-0.9-0.2-1.7-0.6-2.5s-0.9-1.5-1.5-2.1 c-0.6-0.6-1.3-1.1-2.1-1.5c-0.8-0.4-1.6-0.6-2.4-0.6h-45.5c-9.8,0-18.2-3.7-25.3-11.3c-7-7.4-10.6-16.2-10.6-26.1 c0-9.9,3.5-18.5,10.6-26c7-7.6,15.5-11.3,25.3-11.3h78.5v33.8h-74.1c-0.9,0-1.7,0.2-2.5,0.6c-0.8,0.4-1.5,0.9-2.1,1.5 c-0.6,0.6-1.1,1.3-1.5,2.1c-0.4,0.8-0.6,1.6-0.6,2.4c0,1.8,0.7,3.3,2,4.6c1.3,1.3,2.9,2,4.6,2h45.5c9.7,0,18.1,3.8,25.3,11.3 C303.6,114.5,307.1,123.2,307.1,133.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.9,35.3V17c0-4.3,3.5-7.7,7.7-7.7h18.3c4.3,0,7.7,3.5,7.7,7.7v18.3c0,4.3-3.5,7.7-7.7,7.7h-18.3 C316.3,43,312.9,39.6,312.9,35.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M538.5,109.2c0,20.2-16.2,36.7-36.5,37.1h-0.6c-20.4,0-37.1-16.6-37.1-37.1c0-20.4,16.6-37.1,37.1-37.1h0.6 C522.3,72.5,538.5,88.9,538.5,109.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M657.5,59.8c-7.6-7.6-16.8-11.4-27.4-11.4h-56.2h-6.5H566h-18.7H506h0.9c33.2,0.6,59.9,27.6,59.9,60.8 s-26.6,60.2-59.9,60.8H506h41.3h20H581v-29.2h49.1c10.7,0,19.8-3.8,27.4-11.4c7.6-7.6,11.4-16.8,11.4-27.4V87.2 C669,76.5,665.1,67.4,657.5,59.8 M635.2,98.9c0,1-0.2,2-0.6,3c-0.4,1-1,1.8-1.8,2.6c-0.7,0.7-1.6,1.3-2.6,1.8c-1,0.5-2,0.7-3,0.7 H581V82.1h46.2c1,0,2,0.2,3,0.6c1,0.4,1.8,1,2.6,1.8c0.7,0.7,1.3,1.6,1.8,2.6c0.4,1,0.6,2,0.6,3V98.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "750.5,155.8 750.5,136.8 708.4,136.8 708.4,123.6 750.5,123.6 750.5,95.7 708.4,95.7 708.4,82.6  750.5,82.6 750.5,63.4 774.4,63.4 774.4,48.8 674.8,48.8 674.8,170.4 774.3,170.4 774.3,155.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "776.6,48.8 819.1,48.8 860.6,109.7 819.1,170.4 776.6,170.4 818,109.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.4,85.9c-0.4-9.9-4.3-18.4-11.5-25.6c-7.6-7.6-16.8-11.4-27.4-11.4h-43l-0.1,33.8h40.2c1,0,2,0.2,3,0.6 c1,0.4,1.8,1,2.6,1.8c0.7,0.7,1.3,1.6,1.8,2.6c0.4,1,0.6,2,0.6,3v79.8h33.8C434.3,170.4,434.4,93.4,434.4,85.9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.9,
    y: 48.8,
    className: "st0",
    width: 33.8,
    height: 121.6
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M23.2,117.1c0,0,1.1,7.6,19.5,20l1.5,0.6c0,0,52.2-13.5,65.2-32.6c0,0,1-1.5,0.7-3 c-0.1-0.6-0.5-1.1-1-1.4c-0.1-0.1-0.4-0.2-0.4-0.2c-0.1,0-0.2,0-0.3,0c-5.9-0.4-34.6-3-44.2-12.5 C64.1,87.9,23.7,103.1,23.2,117.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -69.652,
    y1: 650.437,
    x2: -68.652,
    y2: 650.437,
    gradientTransform: "matrix(86.9517 0 0 -86.9517 6079.5352 56669.4297)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A01BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A50FAE"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.2,
    y: 87.9,
    className: "st2",
    width: 87.2,
    height: 49.8
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M22.9,117.5c3.7,9.5,20.3,20,20.3,20c2.1-0.5,35.6-14.5,35.6-14.5c-19.6-2.4-37.6-21.5-37.6-21.5L39,98.9 C23.3,103,22.9,117.5,22.9,117.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -69.652,
    y1: 650.3412,
    x2: -68.652,
    y2: 650.3412,
    gradientTransform: "matrix(34.6842 -13.3582 -13.3582 -34.6842 11129.6953 21753.7344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5901B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1972,
    style: {
      stopColor: "#5901B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    style: {
      stopColor: "#6B02A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7685,
    style: {
      stopColor: "#7503A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7503A4"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "10,103.9 71.6,80.2 91.7,132.5 30.1,156.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.5,21.8c0,0-65.4,25-70.2,26.6C43.5,50,2.8,72.4,22.5,116.8l0.6,1.2c0,0-4.5-14.5,54.7-35.1 C77.8,82.9,131.1,63.5,118.5,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 22.8,
    y: 21.8,
    width: 97.6,
    height: 96.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M22.9,114.1c0,0-2.1-24.5,18.9-37.1c0,0,11-6.5,26-11.4c15.1-5,40.4-17.8,46.8-32.9 c0,0,2.5-5.9,3.9-10.9c0,0,3.1,9,1.4,18.8c-1.8,10.1-9.9,32.6-56,47.5c0,0-39.7,14.5-40.8,29.9L22.9,114.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -69.652,
    y1: 650.4361,
    x2: -68.652,
    y2: 650.4361,
    gradientTransform: "matrix(95.1671 -21.6323 -21.6323 -95.1671 20733.2988 60471.6875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4CE2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1571,
    style: {
      stopColor: "#4FD6C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#2DB1CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9023,
    style: {
      stopColor: "#0B8CD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B8CD8"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "0,26.5 116.7,0 142.4,113.3 25.7,139.8  "
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_12_",
    x: 17.1,
    y: 41.8,
    width: 49,
    height: 76.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_14_",
    d: "M64,88.1c0,0-17.2-21.9,2.2-46.3l-17.8,6.7c0,0-17,6.9-26.1,24.6c-1.9,3.7-3.4,7.5-4.3,12.5 c0,0-3.6,15.7,5.3,32.6c0,0-0.5-1.9,2.1-5.8c0.4-0.7,1-1.4,1.6-2.1c0.7-0.9,1.8-2,2.8-2.9c1-0.9,1.9-1.7,2.9-2.5 c1.1-0.8,2.3-1.8,3.4-2.5C44.2,96.6,53.2,92.4,64,88.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_15_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_14_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -69.652,
    y1: 650.437,
    x2: -68.652,
    y2: 650.437,
    gradientTransform: "matrix(49.0358 0 0 -49.0358 3432.5513 31974.5879)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4CE2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1571,
    style: {
      stopColor: "#4FD6C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#2DB1CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9023,
    style: {
      stopColor: "#0B8CD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B8CD8"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2,
    y: 41.8,
    className: "st9",
    width: 51.9,
    height: 76.3
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 23.1,
    y: 88.1,
    width: 48.3,
    height: 29.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M64,88.1c0,0,3.3,3.1,7.5,4.8c0,0-44.1,7.7-48.3,25.1c0,0,0.2-4.6,4.5-9.4c7.3-8.1,23.9-15.2,23.9-15.2 L64,88.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: 36,
    y: 100.5,
    width: 73.1,
    height: 36.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M36,132.3c0,0,55.7-17.3,65.3-23c0,0,8.2-4.4,7.3-8.8c0,0,0.5,0.5,0.4,1.9c-0.1,2-2.1,4.3-6.1,7.4 c-0.7,0.5-3.1,2-7,4.2c-1.9,1-4.2,2.2-6.7,3.5c-3.2,1.7-16.2,7.4-20.5,9c-12.1,4.6-24.9,9.9-26,10.9 C42.9,137.2,38.6,134.5,36,132.3"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M108.5,104c-2.9,5.5-15,11.6-26.4,16.7c-14,6.3-27.5,11-30.1,12c-21.4,8.2-24.5,19.1-25,21.4 c-2.1,9.8,3.4,21.7,11.5,30.1c0,0-6.7-11.9,20.5-22.1c27.3-10.3,42.8-12.1,50.6-18.4c0,0,3-2.1,5.8-6.4 c4.6-7.1,8.9-19.1-0.7-31.8c-1.3-1.8-3.1-3.2-5-4.3c-0.4-0.3-0.8-0.5-1.2-0.6C108.6,100.5,109.6,101.9,108.5,104"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: -69.652,
    y1: 650.437,
    x2: -68.652,
    y2: 650.437,
    gradientTransform: "matrix(93.903 0 0 -93.903 6567.0991 61220.293)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8CF72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F54ED1"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9,
    y: 100.5,
    className: "st14",
    width: 99.4,
    height: 83.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_24_",
    d: "M114.2,113.3c-0.2,9.5-8.4,15.5-16.7,19.4c-9.6,4.5-53.6,15.3-61.2,29c-6.1,11,2.2,22.5,2.2,22.5 c-0.1-1.3-0.8-3.6,0.2-6.4c1.1-3,3.8-6.9,10.6-10.9c0,0,0.6-0.4,2.2-1.2c2.3-1.2,4.9-2.4,8-3.5c27.1-10.2,42.6-12.1,50.5-18.3 c0.3-0.2,0.6-0.5,0.9-0.7c0.1-0.1,0.2-0.1,0.3-0.2c0.6-0.5,1.1-1,1.7-1.6c3.4-3.7,6.3-9.1,7.5-14.2c0-0.2,0.1-0.3,0.1-0.5 c0,0,0-0.1,0-0.1c0.3-1.3,0.4-2.6,0.5-4c0,0,0,0,0,0c0-0.3,0-0.5,0-0.8c0-6.7-3.3-12.8-6.6-16.8c-0.2-0.2-0.4-0.4-0.6-0.6 c-0.7-0.8-1.4-1.4-2.1-1.9c-0.1,0-0.4-0.3-0.9-0.6c-0.4-0.2-0.8-0.5-1.2-0.7c-0.2-0.1-0.9-0.5-1-0.5 C108.7,100.6,114.4,103.5,114.2,113.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_25_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_24_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: -69.652,
    y1: 650.437,
    x2: -68.652,
    y2: 650.437,
    gradientTransform: "matrix(86.9349 0 0 -86.9349 6089.2236 56687.9922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7E9A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F27CD1"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2,
    y: 100.5,
    className: "st15",
    width: 90.8,
    height: 83.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: 42.6,
    y: 100.5,
    width: 78.4,
    height: 39.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_29_",
    d: "M42.6,137.1c0,0,63.9,6.9,72.8,0.2c0,0,5.4-5.4,5.5-16.2c0,0,0.2-5.2-3.7-12c0,0-2-3.5-4.1-5.4 c0,0-2.5-2.3-4.6-3.2c0,0,4.2,4.5-13.3,13.8c-4.1,2.2-9.6,4.8-16.9,8c-3.5,1.5-6.8,2.9-12,5c-5,2-10.2,3.8-16,6.1 C46.1,135,44.3,136.2,42.6,137.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: -69.652,
    y1: 650.4128,
    x2: -68.652,
    y2: 650.4128,
    gradientTransform: "matrix(78.3868 0 0 -78.3868 5502.3809 51106.0039)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48AA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF59CD"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6,
    y: 100.5,
    className: "st18",
    width: 78.6,
    height: 43.5
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.05199bbeda522c9a9155fd484a0892ee.svg";
export { ForwardRef as ReactComponent };